// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__3Zzob","ExitBtn":"Modal__ExitBtn__3S0JC","A":"Modal__A__1dH-M","B":"Modal__B__3BqKq"};


//////////////////
// WEBPACK FOOTER
// ./src/UI/Modal/Modal.css
// module id = 250
// module chunks = 0